<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      Settings can be changed at any time after initial setup
      <b-button class="float-right" variant="link" @click="$parent.$emit('toggle', false)">Exit Quick Guide</b-button>
    </p>
    <b-card-group>
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              You have installed a new agent!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>
                    Copy settings to another server
                  </strong>
                  <hr>
                  <p>Apply other Web firewall settings to that server</p>
                  <hr>
                  <p>
                    Select Agent -> Apply to Other Servers -> Save
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="info" @click="next()">
                <b-card-text>
                  <p style="font-size: 1.7rem;">
                    configuration Policy
                  </p>
                  <hr>
                  <p style="font-size: 1.4rem;">Apply minimal policy for detection log verification</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            <h4 class="mt-2">* Select the level of the server you installed</h4>
            Depending on the step, there are differences in the number of policies used, detection by policy, and prevention
            <strong>Steps for quick setup allow for additional policy optimization, exception handling, etc</strong>
          </b-col>
        </b-row>
        <hr>
        <b-row class="">
          <b-col md="6">
            <VueApexCharts style="max-width:50%; margin: 0px auto;" type="pie" ref="_chart_policy" :options="info.chart.policy.option" :series="info.chart.policy.series" />
          </b-col>
          <b-col class="text-left">
            <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                Test Steps
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'A step for testing and testing the use of each policy Use it when proceeding with the PoC'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (All unused, phased activation)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                Detection Mode
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'This step is to set it up when you use it for the first time in installation and test mode. Set it to general policy detection such as OWASP TOP 10 to see what type of attack is coming in'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Policy detection modes such as OWASP TOP 10, excluding exclusion policies)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
                Block Mode
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'All policies except exclusion policies are set to detection mode Recommended policy steps before blocking'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Full policy blocking settings, excluding exclusion policies)

              </b-form-radio>
              <!-- <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="0">
                Test Steps
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'A step for testing and testing the use of each policy Use it when proceeding with the PoC'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (All unused, phased activation)

              </b-form-radio>

              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1">
                an early stage
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'This step is to set it up when you use it for the first time in installation and test mode. Set it to general policy detection such as OWASP TOP 10 to see what type of attack is coming in'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Focused on detection)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="1.5">
                Initial Expansion Phase
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'All policies except exclusion policies are set to detection mode Recommended policy steps before blocking'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (OWASP TOP 10, Suspected attack detection)

              </b-form-radio> -->
            </b-col>
            <!-- <b-col class="text-left">
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="2">
                the mid-term stage
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'After operating the detection period for a certain period of time, it is a step to block basic attacks such as OWASP TOP 10'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Common Attack Blocking)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="3">
                a long-term stage
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="`It\'s a step where proper detection and blocking are mixed More sites can lead to more misattemptions and need policy optimization`">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Cut-off, including advanced attacks)

              </b-form-radio>
              <b-form-radio style="cursor: pointer; display:block; margin:20px;" @change="change_level" v-model="level" name="level" value="4">
                Final stage
                <span class="text-info d-inline-block" v-b-tooltip.hover.bottom="'This is a step that recommends blocking operations, excluding exclusion policies Setting is recommended after some policy optimization has progressed as a step to prevent an overall attack'">
                  <i class="fa fa-question-circle"></i>
                </span>
                <br>
                (Blocks all policies, blocks advancement, blocks suspected connectivity attacks)
              </b-form-radio>
          </b-col> -->
        </b-row>
      </b-card>
      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">

      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> Prev </b-button>
    <b-button v-if="step < 2"  block size="sm" variant="primary" @click="next()">Next </b-button>
    <b-button v-if="step == 2" class="btn-add"  block size="sm" variant="success" @click="modal_save = true">Save </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="Policy Apply to agent(WAF)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      Do you want to apply the settings?
      <hr>
      Quick setup can be restarted after saving
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
